import React from 'react';
import { Briefcase, DollarSign, Lock, AlertCircle } from 'lucide-react';
import { MetricCard } from '../ui/MetricCard';
import { SectionHeader } from '../ui/SectionHeader';
import { loanOfficers, companyTotals } from '../data/mockData';
export function PipelineSection() {
  const formatCurrency = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(val);
  return <section className="space-y-6 animate-in fade-in duration-500" data-id="element-102">
      <SectionHeader title="Pipeline (Future Revenue)" description="Monitoring active opportunities and pipeline health." data-id="element-103" />

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-104">
        <MetricCard title="Active Apps" value={companyTotals.pipeline.activeApps} icon={Briefcase} color="blue" data-id="element-105" />
        <MetricCard title="Submitted Not Locked" value={formatCurrency(companyTotals.pipeline.submittedVol)} icon={DollarSign} data-id="element-106" />
        <MetricCard title="Locked Not Funded" value={formatCurrency(companyTotals.pipeline.lockedVol)} icon={Lock} data-id="element-107" />
        <MetricCard title="Avg Coverage Ratio" value={`${companyTotals.pipeline.avgCoverage}x`} icon={AlertCircle} color={companyTotals.pipeline.avgCoverage >= 3 ? 'green' : 'red'} subValue="Goal: 3.0x" data-id="element-108" />
      </div>

      {/* Pipeline Table */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-109">
        <div className="overflow-x-auto" data-id="element-110">
          <table className="w-full text-sm text-left" data-id="element-111">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-112">
              <tr data-id="element-113">
                <th className="px-6 py-4" data-id="element-114">Loan Officer</th>
                <th className="px-6 py-4 text-right" data-id="element-115">Active Apps</th>
                <th className="px-6 py-4 text-right" data-id="element-116">Submitted ($)</th>
                <th className="px-6 py-4 text-right" data-id="element-117">Locked ($)</th>
                <th className="px-6 py-4 text-right" data-id="element-118">Pipeline Size</th>
                <th className="px-6 py-4 text-center" data-id="element-119">Coverage</th>
                <th className="px-6 py-4 w-1/3" data-id="element-120">Aging Buckets (Days)</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-121">
              {loanOfficers.map(lo => <tr key={lo.id} className="hover:bg-slate-50 transition-colors" data-id="element-122">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-123">
                    {lo.name}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-124">
                    {lo.pipeline.activeApps}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-125">
                    {formatCurrency(lo.pipeline.submittedNotLockedVol)}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-126">
                    {formatCurrency(lo.pipeline.lockedNotFundedVol)}
                  </td>
                  <td className="px-6 py-4 text-right font-medium text-slate-900" data-id="element-127">
                    {formatCurrency(lo.pipeline.avgPipelineSize)}
                  </td>

                  {/* Coverage Ratio Badge */}
                  <td className="px-6 py-4 text-center" data-id="element-128">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${lo.pipeline.coverageRatio >= 3 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-129">
                      {lo.pipeline.coverageRatio}x
                    </span>
                  </td>

                  {/* Aging Buckets Visualization */}
                  <td className="px-6 py-4" data-id="element-130">
                    <div className="flex flex-col gap-1" data-id="element-131">
                      <div className="flex h-3 w-full rounded-full overflow-hidden bg-slate-100" data-id="element-132">
                        <div style={{
                      flex: lo.pipeline.aging.days0_7
                    }} className="bg-green-400" title="0-7 Days" data-id="element-133" />
                        <div style={{
                      flex: lo.pipeline.aging.days8_14
                    }} className="bg-blue-400" title="8-14 Days" data-id="element-134" />
                        <div style={{
                      flex: lo.pipeline.aging.days15_30
                    }} className="bg-amber-400" title="15-30 Days" data-id="element-135" />
                        <div style={{
                      flex: lo.pipeline.aging.days30plus
                    }} className="bg-red-400" title="30+ Days" data-id="element-136" />
                      </div>
                      <div className="flex justify-between text-[10px] text-slate-400" data-id="element-137">
                        <span data-id="element-138">0-7d</span>
                        <span data-id="element-139">8-14d</span>
                        <span data-id="element-140">15-30d</span>
                        <span data-id="element-141">30+d</span>
                      </div>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}